import { create } from 'zustand';
import { RydMixer } from '../audio/mixer';

export interface MixerStore {
    updateCount: number;
    mixer?: RydMixer.Mixer;
    setMixer: (ctx: RydMixer.Mixer) => void;
    resetMixer: () => void;
    forceUpdate: () => void;
}

export const useMixerStore = create<MixerStore>((set) => ({
    updateCount: 0,
    mixer: undefined,
    setMixer: (m) => set({ mixer: m }),
    resetMixer: () => set({ mixer: undefined }),
    forceUpdate: () => set((state) => ({ updateCount: state.updateCount + 1 })),
}));

